import * as ng from 'angular';

let SetScrollHeightDirectiveFactory: ng.Injectable<ng.IDirectiveFactory> = function ($window: ng.IWindowService) {
    return {
        restrict: 'A',
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes) => {

            let setScrollHeight = () => {
                let clientHeight = ($window.innerHeight
                    || $window.document.documentElement.clientHeight
                    || $window.document.body.clientHeight);

                element[0].style.height = (clientHeight - (attributes as any).offsetPixels).toString() + 'px';
            };

            // add scrollbar if content is larger than element height
            element[0].style.overflowY = 'auto';
            // on change to content in watchExpression, run setScrollHeight
            scope.$watch((attributes as any).watchExpression, setScrollHeight);
            // on resize/stretch of browser, run setScrollHeight
            ng.element($window).bind('resize', () => { setScrollHeight(); });
        }
    }
};

SetScrollHeightDirectiveFactory.$inject = ['$window'];

export let SetScrollHeight = {
    name: 'setScrollHeight',
    factory: SetScrollHeightDirectiveFactory
};




// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/core/set-scroll-height.ts